module.exports = __webpack_public_path__ + "static/img/企业文化8.0ef09568.png";